import { format } from 'date-fns'

export const DateConverterWord = (date: Date | string): string => {
  return format(date, 'd MMMM yyyy')
}
